<template>
    <div class="block-event" :class="classes" @click="onClick">
        <block-event-img class="block-event__img" :id="id" />
        <span class="block-event__time" v-if="showTimeout">
            <span>{{ time }}</span>
        </span>
    </div>
</template>

<script>
    export default {
        props: {
            id: {
                type: Number,
                required: true
            },
            timeout: {
                type: Number,
                default: 0
            },
            showTimeout: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                hide: false
            }
        },
        computed: {
            classes () {
                return {
                    [`block-event--id-${this.id}`]: true,
                    [`block-event--small`]: this.showTimeout && this.timeout < 1500,
                    [`block-event--hide`]: this.hide
                }
            },

            sec () {
                return Math.ceil(this.timeout/1000)
            },

            time () {
                return ('0' + this.sec).slice(-2)
            }
        },
        methods: {
            onClick () {
                this.$emit('click')
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .block-event {
        position relative
        width 6.8rem
        height @width
        background url('~@/assets/images/event-bg.svg')
        background-size cover
        display flex
        align-items center
        justify-content center
        transition transform 1.5s ease

        +layout-md() {
            width 5.4rem
            height @width
        }

        &__time {
            width 1.8rem
            height 1.8rem
            position absolute
            background-color #FF6933
            border-radius 50%
            font-size 1rem
            color #FFFFFF
            display flex
            align-items center
            justify-content center
            right 0
            bottom 0
            span {
                display block
                transform translate(0, -0.1rem)
            }
        }

        &__img {
            width 4.2rem
            +layout-md() {
                width 3.2rem
            }
        }

        &--id-0 &__img {
            width 5.4rem
            +layout-md() {
                width 4.2rem
            }
        }
        &--id-1 &__img {}
        &--id-2 &__img {}
        &--id-3 &__img {}
        &--id-4 &__img {
            width 4.4rem
            +layout-md() {
                width 3.6rem
            }
        }

        &--small {
            transform scale(0.5)
        }
    }
</style>
